import { Divider, Form } from 'antd';
import { PageProps } from '@/types/PageProps';
import { DefaultRouteTabs } from '@/components/_common';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import FiscalSalesByCSTForm from '@/components/Reports/FiscalReports/FiscalSalesByCSTForm';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useReportHandlers } from '@/hooks/useReportHandler';
import { useSalesByCstReport } from '@/core/domain/questReport/Reports/SalesByCst/SalesByCst.hook';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import {
  QuestReportSalesByCstRequest,
  QuestSalesByCstFormValues,
} from '@/core/domain/questReport/Reports/SalesByCst/SalesByCst.types';
import { QuestResponseType } from '@/core/domain/questReport/Reports/Quotation/Quotation.types';
import { DateTimeFormat } from '@/utils/moment';

const SalesByCST = ({ route }: PageProps) => {
  const intl = useIntl();
  const [form] = Form.useForm<QuestSalesByCstFormValues>();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const generateReport = useSalesByCstReport();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const { companiesIds, cstPisCofins, initialDate, finalDate, ...values } =
        await form.validateFields();

      const obj: QuestReportSalesByCstRequest = {
        ...values,
        cstPisCofins: cstPisCofins?.toString(),
        companiesIds: companiesIds?.toString(),
        responseType:
          format === 'CSV' ? QuestResponseType.CSV : QuestResponseType.PDF,
        startDate: initialDate.format(DateTimeFormat),
        endDate: finalDate.format(DateTimeFormat),
        cfopIdsToInhibit: values.cfopIdsToInhibit?.toString(),
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'relatorio_vendas_por_CST',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <FiscalSalesByCSTForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
};

export default SalesByCST;
